import styled from "styled-components";
import { ProjectPreviewText } from "../../constants/titles";
import { tangerine } from "../../constants/colorConstants";

export const ProjectPhoto = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
    transition: transform 0.4s ease;
    border-radius: 15px;
    opacity: 1;

    @media (max-width: 414px) {
        height: 20vh;
        width: 50vw;
    }
`;

export const ArrowBadge = styled.div`
    position: absolute;
    bottom: 12px;
    right: 12px;
    background: ${tangerine};
    color: #ffffff;
    font-family: ${ProjectPreviewText};
    font-size: 0.85rem;
    font-weight: 600;
    padding: 6px 14px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    gap: 6px;
    opacity: 0;
    transform: translateY(8px);
    transition: opacity 0.3s ease, transform 0.3s ease;
    pointer-events: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);

    @media (max-width: 414px) {
        opacity: 1;
        transform: translateY(0);
        font-size: 0.75rem;
        padding: 4px 10px;
    }
`;

export const ProjectPreviewWrapper = styled.a`
    position: relative;
    width: 30vw;
    height: 18vw;
    border-radius: 20px;
    border: 4px solid ${props => props.theme.colors.PROJECT_PREVIEW_BORDER};
    margin-left: 4vw;
    margin-top: 4vh;
    background-color: ${props => props.theme.colors.PROJECT_PREVIEW_OVERLAY};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    transition: transform 0.35s ease, box-shadow 0.35s ease, border-color 0.35s ease;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    @media (max-width: 414px) {
        width: 50vw;
        height: 20vh;
    }

    @media (min-width: 414px) {
        &:hover {
            transform: translateY(-6px);
            box-shadow: 0 12px 24px -6px rgba(0, 0, 0, 0.3);
            border-color: ${tangerine};
            ${ProjectPhoto} {
                transform: scale(1.06);
            }
            ${ArrowBadge} {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }
`;

export const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-left: 4vw;
    margin-top: 1.5vh;
    margin-bottom: 2vh;
`;

export const TagBadge = styled.span`
    background-color: ${props => props.theme.colors.PROJECT_PREVIEW_BORDER};
    color: #ffffff;
    font-family: ${ProjectPreviewText};
    font-size: 0.85rem;
    font-weight: 600;
    padding: 4px 12px;
    border-radius: 20px;
    letter-spacing: 0.3px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transition: transform 0.2s ease;

    &:hover {
        transform: translateY(-2px);
    }
`;


